module.exports = __webpack_public_path__ + "static/media/near.f0473a8f.png";